import { useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "../styles/headerTabListItem.module.css";
import { TAB } from "./headerTabList";

export const HeaderTabListItem = ({ tab, navigate }: { tab: TAB; navigate: Function }) => {
  const [hover, setHover] = useState(false);
  const location = useLocation();

  // Determine if the current tab is active
  const isActive = location.pathname === tab.navigation;

  // You can further refine this to handle more complex scenarios or paths
  const isDropdownItemActive = (dropdownNavigation: any) => {
    return location.pathname.startsWith(dropdownNavigation);
  };

  return (
    <>
      <div
        onClick={() => tab.navigation && navigate(tab.navigation)}
        className={`${styles.wrapper} ${isActive ? styles.active : ""}`}
        onMouseEnter={() => {
          setHover(true);
        }}
        onMouseLeave={() => {
          setHover(false);
        }}
      >
        <div className={styles.tab}>
          {tab.icon}
          <p>{tab.title}</p>
        </div>
        {tab.dropDown && hover ? (
          <div
            className={styles.dropDown}
            onMouseEnter={() => {
              setHover(true); // Keep the dropdown open when hovering over it
            }}
            onMouseLeave={() => {
              setHover(false); // Close the dropdown when leaving it
            }}
          >
            {tab.dropDown.map((item: any, index: number) => (
              <div
                key={index}
                onClick={() => {
                  navigate(item.navigation);
                }}
                className={styles.dropDownItem}
              >
                <p>{item.title}</p>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </>
  );
};
